import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73e58166"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-button-img-container" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routeChoice(_ctx.event)))
    }, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("h5", null, _toDisplayString(_ctx.place) + "  •  " + _toDisplayString(_ctx.hour), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: _ctx.link,
        target: "_new"
      }, [
        _withDirectives(_createVNode(_component_Button, {
          text: 
            this.$store.state.language === 'fr' ? 'Billetterie' : 'Tickets'
          ,
          mainColor: "var(--colorAccent)",
          hoverColor: "var(--colorPrimary)"
        }, null, 8, ["text"]), [
          [_vShow, this.link?.length > 0]
        ])
      ], 8, _hoisted_3),
      _withDirectives(_createElementVNode("img", {
        class: "card-img-container",
        src: this.image,
        alt: _ctx.title,
        style: _normalizeStyle(_ctx.styles),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routeChoice(_ctx.event)))
      }, null, 12, _hoisted_4), [
        [_vShow, !this.image.includes(undefined)]
      ])
    ])
  ]))
}